import { Navigate } from "react-router-dom";
import { useEffect } from "react";
import { isAuthenticated } from "../services/sessionManager";

const CustomerRoute = ({ children, setShowLoginModal }) => {
  const isLoggedIn = isAuthenticated();

  useEffect(() => {
    if (!isLoggedIn) {
      setShowLoginModal(true);
    }
  }, [isLoggedIn, setShowLoginModal]);

  if (!isLoggedIn) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default CustomerRoute;
